export interface Doctors {
    aliens: number[],
    cyborgs: number[],
    ghosts: number[],
    zombies: number[],
    legends: number[],
}

export function filterDoctors(tokens: number[]): Doctors {
    var aliens: number[] = []
    var cyborgs: number[] = []
    var ghosts: number[] = []
    var zombies: number[] = []
    var legends: number[] = []

    for (let index = 0; index < tokens.length; index++) {
        const token = tokens[index];

        if (token == 25 || token == 100 || token == 700 || token == 1000 || token == 1450 || token == 2000 || token == 2600 || token == 3000 || token == 3328 || token == 3329 || token == 3330 || token == 3331 || token == 3332 || token == 3333) {
            legends.push(token)
        } else if (token == 3320 || token == 3321) {
            aliens.push(token)
        } else if (token > 3319) {
            //
        } else if (token == 3322 || token == 3323) {
            zombies.push(token)
        } else if (token > 450) {
            zombies.push(token)
        } else if (token > 250) {
            ghosts.push(token)
        } else if (token > 150) {
            cyborgs.push(token)
        } else {
            aliens.push(token)
        }
    }

    return { aliens, cyborgs, ghosts, zombies, legends }
}